export interface NotificationSettingsEntity {
  userId: string;
  assignedTasksPush: boolean;
  assignedIssuesPush: boolean;
  followCheckinPush: boolean;
  followCheckoutPush: boolean;
  followActivityPush: boolean;
  followInactivityPush: boolean;
  inactivityScope: 'following' | 'all';
  inactivityThresholdMinutes: number;
  followOutOfGeofencePush: boolean;
  outOfGeofenceScope: 'following' | 'all';
}

/** Column defaults from the DB (assigned_* default true, follow_* default false, followOutOfGeofencePush default true). */
export function defaultNotificationSettings(userId: string): NotificationSettingsEntity {
  return {
    userId,
    assignedTasksPush: true,
    assignedIssuesPush: true,
    followCheckinPush: false,
    followCheckoutPush: false,
    followActivityPush: false,
    followInactivityPush: false,
    inactivityScope: 'following',
    inactivityThresholdMinutes: 30,
    followOutOfGeofencePush: true,
    outOfGeofenceScope: 'following',
  };
}
